import { UPDATE_SELECTED_CAB } from '../../SeoPage/redux/seo-action-types';
import { 
  CAB_TYPE_DETAIL_MODAL, 
  HOURLY_RENTALS_DETAILS, 
  UPDATE_AIRPORT_DESTINATION_LAT_LONG,
  UPDATE_AIRPORT_SOURCE_LAT_LONG,
  UPDATE_OS_DESTINATION_LAT_LONG,
  UPDATE_OS_SOURCE_LAT_LONG
}                                 from './action-types';
import { 
  HourlyRentalDetails, 
  IResultsStoreState 
}                                 from "./types";

const initialState: IResultsStoreState = {
  results                       : {},
  filters                       : {},
  selectedCab                   : {},
  isFilterApplied               : false,
  smartengage                   : {},
  loader                        : true,
  hourlyRentalDetails           : {} as HourlyRentalDetails,
  showCabTypeDetailsModal       : false,
  airport_source_lat_long       : null,
  airport_destination_lat_long  : null,
  os_destination_lat_long       : null,
  os_source_lat_long            : null
};

export default function SearchpageReducer(state = initialState, action) {
  switch (action.type) {
    case "UPDATE_RESULTS":
      let results = action.results
      if (action?.results?.common_data?.trip_type_event === "local-rental") {
        results.common_data['trip_type'] = "LOCAL_RENTAL"
      }
      return {
        ...state,
        results:  results,
        isFilterApplied: false,
        loader: false
      };
    case "UPDATE_FILTERS":
      return {
        ...state,
        filters: action.filters,
        isFilterApplied: true
      };
    case "UPDATE_LOADER":
      return {
        ...state,
        results: {}
      };
    case 'CLEAR_FILTER': {
      return {
        ...state,
        results: {},
        filters: {}
      };
    }
    case UPDATE_SELECTED_CAB: {
      return {
        ...state,
        selectedCab: action.selectedCab
      }
    }
    case 'UPDATE_SMARTENGAGE_BANNER': {
      return {
        ...state,
        smartengage: {
          ...state.smartengage,
          ...action.smartengage
        }
      }
    }
    case 'CLEAR_RESULTS': {
      return {
        ...state,
        results: {},
        loader: true
      }
    }
    // fetching data for selected Hourly Rental Details
    case HOURLY_RENTALS_DETAILS : {
      return {
        ...state,
        hourlyRentalDetails : action?.hourlyRentalDetails
      }
    }
    case CAB_TYPE_DETAIL_MODAL : {
      return {
        ...state,
        showCabTypeDetailsModal : action?.showCabTypeDetailsModal
      }
    }

    case UPDATE_AIRPORT_DESTINATION_LAT_LONG : 
      return {
        ...state,
        airport_destination_lat_long: action.airport_destination_lat_long
      }

    case UPDATE_AIRPORT_SOURCE_LAT_LONG : 
      return {
        ...state,
        airport_source_lat_long: action.airport_source_lat_long
      }

    case UPDATE_OS_DESTINATION_LAT_LONG : 
      return {
        ...state,
        os_destination_lat_long: action.os_destination_lat_long
      }

    case UPDATE_OS_SOURCE_LAT_LONG : 
      return {
        ...state,
        os_source_lat_long: action.os_source_lat_long
      }
    default:
      return state;
  }
}
